"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMAGE_UPLOAD_COPY = void 0;
const IMAGE_UPLOAD_COPY = {
    errorFileSize: 'Image is too large and exceeds maximum file size limit.',
    errorFileTypePrefix: 'Unsupported file type. Please provide one of the following:',
    imageHelpLinkText: 'Need help with your image?'
};
exports.IMAGE_UPLOAD_COPY = IMAGE_UPLOAD_COPY;
